<template lang="pug">
    .downloads-container(:class="[spacingTop, spacingBottom]")
        .wrap.container.mx-auto
            ul.no-style-list
                MediaPreview(
                    v-for="content in contents" :key="content.id"
                    :media="content.media[0]"
                    :height="64"
                    :width="61"
                )
</template>

<script>
import { get, cloneDeep } from '@/helpers';

import MediaPreview from './MediaPreview';

export default {
    name: 'Downloads',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        MediaPreview
    },
    computed: {
        contents() {
            let contents = get(this.section, 'contents') || [];

            const isValidMediaObject = media => {
                let isValid = false;
                switch (media.type) {
                    case 'file':
                        isValid = !!get(media, 'file');
                        break;
                    case 'image':
                    case 'video':
                        isValid = !!get(media, `${media.type}.source`);
                        break;
                }
                return isValid;
            };

            contents = cloneDeep(contents)
                .filter(content => {
                    return content.media && content.media.length === 1 && isValidMediaObject(content.media[0]);
                })
                .sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));

            return contents;
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
};
</script>

<style lang="sass" scoped>
.wrap
    margin: 0 auto
</style>
